import * as Updates from "expo-updates";
import Bugsnag from "@bugsnag/expo";
import { APP_ENV } from "../client";

// We can simulate either update here.
const TEST_OTA_UPDATE = false;

const UseUpdates = () => {
  // just check for updates (stubbed for dev mode)
  // can be run multiple times without issue
  const isUpdateAvailable = async () => {
    // Check if an update is available
    const OTAUpdate = !__DEV__
      ? await Updates.checkForUpdateAsync()
      : { isAvailable: TEST_OTA_UPDATE };

    return OTAUpdate?.isAvailable;
  };

  // check for updates and apply them if available
  const checkForAndApplyUpdateAsync = async () => {
    try {
      if (await isUpdateAvailable()) {
        await applyOTAUpdate();
      }
    } catch (e) {
      console.log("[UseUpdates] Error checking for updates: ", e);
      const error = new Error(`[UseUpdates] Error checking for updates: ${e}`);
      Bugsnag.notify(error);
    }
  };

  //the splash screen doesn't need to be hidden since the app reloads
  const applyOTAUpdate = async () => {
    const action = __DEV__ ? "simulating" : "applying";
    Bugsnag.leaveBreadcrumb(`[UseUpdates] started ${action} OTA UPDATE.`);
    console.log(`[UseUpdates] started ${action} OTA UPDATE: `);
    try {
      // this will throw an error if there is no update available
      await Updates.fetchUpdateAsync();
      await Updates.reloadAsync();
    } catch (err) {
      if (__DEV__) {
        // in dev mode, we can simulate an update for 3 seconds
        if (APP_ENV !== "integration")
          await new Promise((resolve) => setTimeout(resolve, 3000));
      } else {
        console.log(`[UseUpdates] Error fetching updates: ${err}`);
        const error = new Error(
          `[UseUpdates] Error applying OTA update: ${err}`
        );
        Bugsnag.notify(error);
      }
    }
    Bugsnag.leaveBreadcrumb(`[UseUpdates] finished ${action} OTA UPDATE.`);
    console.log(`[UseUpdates] finished ${action} OTA UPDATE: `);
  };

  return {
    isUpdateAvailable,
    checkForAndApplyUpdateAsync,
  };
};

export default UseUpdates;
